export const sortOrder = {
  DEFAULT: 'default',
};

export const DEPARTING = 'Departing';
export const RETURNING = 'Returning';
export const tripTypeValues = {
  ONEWAY: 'ONEWAY',
  ROUNDTRIP: 'ROUNDTRIP',
};
